import React from 'react'
import ServiceArea from '../../components/ServiceArea';


export function Airoli() {
    return (
      <div>
        <ServiceArea title = {`Airoli` } tag ="Website Design Services in Airoli"/>
      </div>
    )
  }
  export function Ambernath() {
    return (
      <div>
        <ServiceArea title = {`Ambernath` } tag ="Website Design Services in Ambernath"/>
      </div>
    )
  }
  export function Ambivli() {
    return (
      <div>
        <ServiceArea title = {`Ambivli` } tag ="Website Design Services in Ambivli"/>
      </div>
    )
  }
  export function Andheri() {
    return (
      <div>
        <ServiceArea title = {`Andheri` } tag ="Website Design Services in Andheri"/>
      </div>
    )
  }
  export function Asangaon() {
    return (
      <div>
        <ServiceArea title = {`Asangaon` } tag ="Website Design Services in Asangaon"/>
      </div>
    )
  }
  export function Atgaon() {
    return (
      <div>
        <ServiceArea title = {`Atgaon` } tag ="Website Design Services in Atgaon"/>
      </div>
    )
  }
  export function Badlapur() {
    return (
      <div>
        <ServiceArea title = {`Badlapur` } tag ="Website Design Services in Badlapur"/>
      </div>
    )
  }
  export function Bandra() {
    return (
      <div>
        <ServiceArea title = {`Bandra` } tag ="Website Design Services in Bandra"/>
      </div>
    )
  }
  export function Bhayandar() {
    return (
      <div>
        <ServiceArea title = {`Bhayandar` } tag ="Website Design Services in Bhayandar"/>
      </div>
    )
  }
  export function Bhivpuri() {
    return (
      <div>
        <ServiceArea title = {`Bhivpuri` } tag ="Website Design Services in Bhivpuri"/>
      </div>
    )
  }
  export function Bhiwandi() {
    return (
      <div>
        <ServiceArea title = {`Bhiwandi` } tag ="Website Design Services in Bhiwandi"/>
      </div>
    )
  }
  export function Boisar() {
    return (
      <div>
        <ServiceArea title = {`Boisar` } tag ="Website Design Services in Boisar"/>
      </div>
    )
  }
  export function Borivali() {
    return (
      <div>
        <ServiceArea title = {`Borivali` } tag ="Website Design Services in Borivali"/>
      </div>
    )
  }
  export function Byculla() {
    return (
      <div>
        <ServiceArea title = {`Byculla` } tag ="Website Design Services in Byculla"/>
      </div>
    )
  }
  export function CbdBelapur() {
    return (
      <div>
        <ServiceArea title = {`Cbd-Belapur` } tag ="Website Design Services in CBD Belapur"/>
      </div>
    )
  }
  export function CharniRoad() {
    return (
      <div>
        <ServiceArea title = {`Charni Road` } tag ="Website Design Services in Charni Road"/>
      </div>
    )
  }
  export function Chembur() {
    return (
      <div>
        <ServiceArea title = {`Chembur` } tag ="Website Design Services in Chembur"/>
      </div>
    )
  }
  export function Chinchpokli() {
    return (
      <div>
        <ServiceArea title = {`Chinchpokli` } tag ="Website Design Services in Chinchpokli"/>
      </div>
    )
  }
  export function Chunabhatti() {
    return (
      <div>
        <ServiceArea title = {`Chunabhatti` } tag ="Website Design Services in Chunabhatti"/>
      </div>
    )
  }
  export function Churchgate() {
    return (
      <div>
        <ServiceArea title = {`Churchgate` } tag ="Website Design Services in Churchgate"/>
      </div>
    )
  }
  export function Colaba() {
    return (
      <div>
        <ServiceArea title = {`Colaba` } tag ="Website Design Services in Colaba"/>
      </div>
    )
  }
  export function Cst() {
    return (
      <div>
        <ServiceArea title = {`Cst` } tag ="Website Design Services in CST"/>
      </div>
    )
  }
  export function CurreyRoad() {
    return (
      <div>
        <ServiceArea title = {`Currey Road` } tag ="Website Design Services in Currey Road"/>
      </div>
    )
  }
  export function Dadar() {
    return (
      <div>
        <ServiceArea title = {`Dadar` } tag ="Website Design Services in Dadar"/>
      </div>
    )
  }
  export function Dharavi() {
    return (
      <div>
        <ServiceArea title = {`Dharavi` } tag ="Website Design Services in Dharavi"/>
      </div>
    )
  }
  export function Diva() {
    return (
      <div>
        <ServiceArea title = {`Diva` } tag ="Website Design Services in Diva"/>
      </div>
    )
  }
  export function Dombivli() {
    return (
      <div>
        <ServiceArea title = {`Dombivli` } tag ="Website Design Services in Dombivli"/>
      </div>
    )
  }
  export function Fort() {
    return (
      <div>
        <ServiceArea title = {`Fort` } tag ="Website Design Services in Fort"/>
      </div>
    )
  }
  export function Ghansoli() {
    return (
      <div>
        <ServiceArea title = {`Ghansoli` } tag ="Website Design Services in Ghansoli"/>
      </div>
    )
  }
  export function Ghatkopar() {
    return (
      <div>
        <ServiceArea title = {`Ghatkopar` } tag ="Website Design Services in Ghatkopar"/>
      </div>
    )
  }
  export function Goregaon() {
    return (
      <div>
        <ServiceArea title = {`Goregaon` } tag ="Website Design Services in Goregaon"/>
      </div>
    )
  }
  export function Govandi() {
    return (
      <div>
        <ServiceArea title = {`Govandi` } tag ="Website Design Services in Govandi"/>
      </div>
    )
  }
  export function GrantRoad() {
    return (
      <div>
        <ServiceArea title = {`Grant Road` } tag ="Website Design Services in Grant Road"/>
      </div>
    )
  }
  export function GtbNagar() {
    return (
      <div>
        <ServiceArea title = {`Gtb Nagar` } tag ="Website Design Services in GTB Nagar"/>
      </div>
    )
  }
  export function Jogeshwari() {
    return (
      <div>
        <ServiceArea title = {`Jogeshwari` } tag ="Website Design Services in Jogeshwari"/>
      </div>
    )
  }
  export function Kalamboli() {
    return (
      <div>
        <ServiceArea title = {`Kalamboli` } tag ="Website Design Services in Kalamboli"/>
      </div>
    )
  }
  export function Kalbadevi() {
    return (
      <div>
        <ServiceArea title = {`Kalbadevi` } tag ="Website Design Services in Kalbadevi"/>
      </div>
    )
  }
  export function Kalwa() {
    return (
      <div>
        <ServiceArea title = {`Kalwa` } tag ="Website Design Services in Kalwa"/>
      </div>
    )
  }
  export function Kalyan() {
    return (
      <div>
        <ServiceArea title = {`Kalyan` } tag ="Website Design Services in Kalyan"/>
      </div>
    )
  }
  export function Kamothe() {
    return (
      <div>
        <ServiceArea title = {`Kamothe` } tag ="Website Design Services in Kamothe"/>
      </div>
    )
  }
  export function Kandivali() {
    return (
      <div>
        <ServiceArea title = {`Kandivali` } tag ="Website Design Services in Kandivali"/>
      </div>
    )
  }
  export function Kanjurmarg() {
    return (
      <div>
        <ServiceArea title = {`Kanjurmarg` } tag ="Website Design Services in Kanjurmarg"/>
      </div>
    )
  }
  export function Karjat() {
    return (
      <div>
        <ServiceArea title = {`Karjat` } tag ="Website Design Services in Karjat"/>
      </div>
    )
  }
  export function Kasara() {
    return (
      <div>
        <ServiceArea title = {`Kasara` } tag ="Website Design Services in Kasara"/>
      </div>
    )
  }
export function Khadavli() {
  return (
    <div>
      <ServiceArea title = {`Khadavli` } tag ="Website Design Services in Khadavli"/>
    </div>
  )
}
export function Khar() {
    return (
      <div>
        <ServiceArea title = {`Khar` } tag ="Website Design Services in Khar"/>
      </div>
    )
  }
  export function Khardi() {
    return (
      <div>
        <ServiceArea title = {`Khardi` } tag ="Website Design Services in Khardi"/>
      </div>
    )
  }
  export function Kharghar() {
    return (
      <div>
        <ServiceArea title = {`Kharghar` } tag ="Website Design Services in Kharghar"/>
      </div>
    )
  }
  export function KoparKhairane() {
    return (
      <div>
        <ServiceArea title = {`Kopar Khairane` } tag ="Website Design Services in Kopar Khairane"/>
      </div>
    )
  }
  export function Kopar() {
    return (
      <div>
        <ServiceArea title = {`Kopar` } tag ="Website Design Services in Kopar"/>
      </div>
    )
  }
  export function Kurla() {
    return (
      <div>
        <ServiceArea title = {`Kurla` } tag ="Website Design Services in Kurla"/>
      </div>
    )
  }
  export function LowerParel() {
    return (
      <div>
        <ServiceArea title = {`Lower Parel` } tag ="Website Design Services in Lower Parel"/>
      </div>
    )
  }
  export function Mahalakshmi() {
    return (
      <div>
        <ServiceArea title = {`Mahalakshmi` } tag ="Website Design Services in Mahalakshmi"/>
      </div>
    )
  }
  export function Mahape() {
    return (
      <div>
        <ServiceArea title = {`Mahape` } tag ="Website Design Services in Mahape"/>
      </div>
    )
  }
  export function Mahim() {
    return (
      <div>
        <ServiceArea title = {`Mahim` } tag ="Website Design Services in Mahim"/>
      </div>
    )
  }
  export function Majiwada() {
    return (
      <div>
        <ServiceArea title = {`Majiwada` } tag ="Website Design Services in Majiwada"/>
      </div>
    )
  }
  export function Malad() {
    return (
      <div>
        <ServiceArea title = {`Malad` } tag ="Website Design Services in Malad"/>
      </div>
    )
  }
  export function Mankhurd() {
    return (
      <div>
        <ServiceArea title = {`Mankhurd` } tag ="Website Design Services in Mankhurd"/>
      </div>
    )
  }
  export function MasjidBander() {
    return (
      <div>
        <ServiceArea title = {`Masjid Bander` } tag ="Website Design Services in Masjid Bander"/>
      </div>
    )
  }
  export function Matunga() {
    return (
      <div>
        <ServiceArea title = {`Matunga` } tag ="Website Design Services in Matunga"/>
      </div>
    )
  }
  export function Mazgaon() {
    return (
      <div>
        <ServiceArea title = {`Mazgaon` } tag ="Website Design Services in Mazgaon"/>
      </div>
    )
  }
  export function MiraRoad() {
    return (
      <div>
        <ServiceArea title = {`Mira Road` } tag ="Website Design Services in Mira Road"/>
      </div>
    )
  }
  export function MumbaiCentral() {
    return (
      <div>
        <ServiceArea title = {`Mumbai Central` } tag ="Website Design Services in Mumbai Central"/>
      </div>
    )
  }
  export function Mumbai() {
    return (
      <div>
        <ServiceArea title = {`Mumbai` } tag ="Website Design Services in Mumbai"/>
      </div>
    )
  }
  export function Mumbra() {
    return (
      <div>
        <ServiceArea title = {`Mumbra` } tag ="Website Design Services in Mumbra"/>
      </div>
    )
  }
  export function Nahur() {
    return (
      <div>
        <ServiceArea title = {`Nahur` } tag ="Website Design Services in Nahur"/>
      </div>
    )
  }
  export function Naigaon() {
    return (
      <div>
        <ServiceArea title = {`Naigaon` } tag ="Website Design Services in Naigaon"/>
      </div>
    )
  }
  export function NallaSopara() {
    return (
      <div>
        <ServiceArea title = {`Nalla Sopara` } tag ="Website Design Services in Nalla Sopara"/>
      </div>
    )
  }
  export function Naupada() {
    return (
      <div>
        <ServiceArea title = {`Naupada` } tag ="Website Design Services in Naupada"/>
      </div>
    )
  }
  export function NaviMumbai() {
    return (
      <div>
        <ServiceArea title = {`Navi Mumbai` } tag ="Website Design Services in Navi Mumbai"/>
      </div>
    )
  }
  export function Neral() {
    return (
      <div>
        <ServiceArea title = {`Neral` } tag ="Website Design Services in Neral"/>
      </div>
    )
  }
  export function Nerul() {
    return (
      <div>
        <ServiceArea title = {`Nerul` } tag ="Website Design Services in Nerul"/>
      </div>
    )
  }
  export function Palava() {
    return (
      <div>
        <ServiceArea title = {`Palava` } tag ="Website Design Services in Palava"/>
      </div>
    )
  }
  export function Palghar() {
    return (
      <div>
        <ServiceArea title = {`Palghar` } tag ="Website Design Services in Palghar"/>
      </div>
    )
  }
  export function Panvel() {
    return (
      <div>
        <ServiceArea title = {`Panvel` } tag ="Website Design Services in Panvel"/>
      </div>
    )
  }
  export function Parel() {
    return (
      <div>
        <ServiceArea title = {`Parel` } tag ="Website Design Services in Parel"/>
      </div>
    )
  }
  export function Powai() {
    return (
      <div>
        <ServiceArea title = {`Powai` } tag ="Website Design Services in Powai"/>
      </div>
    )
  }
  export function Prabhadevi() {
    return (
      <div>
        <ServiceArea title = {`Prabhadevi` } tag ="Website Design Services in Prabhadevi"/>
      </div>
    )
  }
  export function Rabale() {
    return (
      <div>
        <ServiceArea title = {`Rabale` } tag ="Website Design Services in Rabale"/>
      </div>
    )
  }
  export function Sakinaka() {
    return (
      <div>
        <ServiceArea title = {`Sakinaka` } tag ="Website Design Services in Sakinaka"/>
      </div>
    )
  }
  export function SandhurstRoad() {
    return (
      <div>
        <ServiceArea title = {`Sandhurst Road` } tag ="Website Design Services in Sandhurst Road"/>
      </div>
    )
  }
  export function Sanpada() {
    return (
      <div>
        <ServiceArea title = {`Sanpada` } tag ="Website Design Services in Sanpada"/>
      </div>
    )
  }
  export function Santacruz() {
    return (
      <div>
        <ServiceArea title = {`Santacruz` } tag ="Website Design Services in Santacruz"/>
      </div>
    )
  }
  export function Shahad() {
    return (
      <div>
        <ServiceArea title = {`Shahad` } tag ="Website Design Services in Shahad"/>
      </div>
    )
  }
  export function Shelu() {
    return (
      <div>
        <ServiceArea title = {`Shelu` } tag ="Website Design Services in Shelu"/>
      </div>
    )
  }
  export function Sion() {
    return (
      <div>
        <ServiceArea title = {`Sion` } tag ="Website Design Services in Sion"/>
      </div>
    )
  }
  export function Taloja() {
    return (
      <div>
        <ServiceArea title = {`Taloja` } tag ="Website Design Services in Taloja"/>
      </div>
    )
  }
  export function Thakurli() {
    return (
      <div>
        <ServiceArea title = {`Thakurli` } tag ="Website Design Services in Thakurli"/>
      </div>
    )
  }
  export function Tilaknagar() {
    return (
      <div>
        <ServiceArea title = {`Tilaknagar` } tag ="Website Design Services in Tilaknagar"/>
      </div>
    )
  }
  export function Titvala() {
    return (
      <div>
        <ServiceArea title = {`Titvala` } tag ="Website Design Services in Titvala"/>
      </div>
    )
  }
  export function Turbhe() {
    return (
      <div>
        <ServiceArea title = {`Turbhe` } tag ="Website Design Services in Turbhe"/>
      </div>
    )
  }
  export function Ulhasnagar() {
    return (
      <div>
        <ServiceArea title = {`Ulhasnagar` } tag ="Website Design Services in Ulhasnagar"/>
      </div>
    )
  }
  export function Ulwe() {
    return (
      <div>
        <ServiceArea title = {`Ulwe` } tag ="Website Design Services in Ulwe"/>
      </div>
    )
  }
  export function Umroli() {
    return (
      <div>
        <ServiceArea title = {`Umroli` } tag ="Website Design Services in Umroli"/>
      </div>
    )
  }
  export function Vangani() {
    return (
      <div>
        <ServiceArea title = {`Vangani` } tag ="Website Design Services in Vangani"/>
      </div>
    )
  }
  export function Vashi() {
    return (
      <div>
        <ServiceArea title = {`Vashi` } tag ="Website Design Services in Vashi"/>
      </div>
    )
  }
  export function Vasind() {
    return (
      <div>
        <ServiceArea title = {`Vasind` } tag ="Website Design Services in Vasind"/>
      </div>
    )
  }
  export function Versova() {
    return (
      <div>
        <ServiceArea title = {`Versova` } tag ="Website Design Services in Versova"/>
      </div>
    )
  }
  export function Vidyavihar() {
    return (
      <div>
        <ServiceArea title = {`Vidyavihar` } tag ="Website Design Services in Vidyavihar"/>
      </div>
    )
  }
  export function Vikhroli() {
    return (
      <div>
        <ServiceArea title = {`Vikhroli` } tag ="Website Design Services in Vikhroli"/>
      </div>
    )
  }
  export function VilleParle() {
    return (
      <div>
        <ServiceArea title = {`Ville Parle` } tag ="Website Design Services in Ville Parle"/>
      </div>
    )
  }
  export function Virar() {
    return (
      <div>
        <ServiceArea title = {`Virar` } tag ="Website Design Services in Virar"/>
      </div>
    )
  }
  export function Vithalwadi() {
    return (
      <div>
        <ServiceArea title = {`Vithalwadi` } tag ="Website Design Services in Vithalwadi"/>
      </div>
    )
  }
  export function WagleEstate() {
    return (
      <div>
        <ServiceArea title = {`Wagle Estate` } tag ="Website Design Services in Wagle Estate"/>
      </div>
    )
  }
  export function Worli() {
    return (
      <div>
        <ServiceArea title = {`Worli` } tag ="Website Design Services in Worli"/>
      </div>
    )
  }
  export function Thane() {
    return (
      <div>
        <ServiceArea title = {`Thane` } tag ="Website Design Services in Thane"/>
      </div>
    )
  }
  export function Bhandup() {
    return (
      <div>
        <ServiceArea title = {`Bhandup` } tag ="Website Design Services in Bhandup"/>
      </div>
    )
  }


